import { schemes, zSchema, cardSchema } from "@zeal/common";

export const getWorkerAstraCardRequestSchema = zSchema.object({
  workerID: schemes.mongoObjectId(),
  deleted: zSchema.boolean().optional(),
});

export type TGetWorkerAstraCardRequestSchema = zSchema.infer<
  typeof getWorkerAstraCardRequestSchema
>;

export const getWorkerAstraCardResponseSchema = zSchema.array(cardSchema);

export type TGetWorkerAstraCardResponseSchema = zSchema.infer<
  typeof getWorkerAstraCardResponseSchema
>;
